<template>
<div @load="modal">
</div>
</template>
<script>
export default {

    data() {
        return {
            tela: true,
            modal: this.$bvModal.show('login2'),
        }
    }
}
</script>
